__turbopack_context__.v({
  "centeredStyle": "TextInput-module__zqDPxG__centeredStyle",
  "container": "TextInput-module__zqDPxG__container",
  "disabled": "TextInput-module__zqDPxG__disabled",
  "input": "TextInput-module__zqDPxG__input",
  "inputActive": "TextInput-module__zqDPxG__inputActive",
});
